Agent_content = {
	init : function(){
		console.log('AGENT CONTENT INIT');
		
		// Check if any Agent Content elements are on page.
		if( jQuery( '[data-oc-id="agent-content"]' ).size() == 0 )
		{
			return false;
		}
		
		// Get Agent data.
		var url = 'library/property/services/agent-data.php';
		var config = new Object();
		config.cache = false;
		
		// Call data.
		Agent_data_oncloud.get_data(url, config);
		
		// Respond to AJAX property list data received.
		jQuery(document).on('oc_agent_data_retrieval',function(event,response){
			console.log('OC AGENT DATA RETRIEVED',response);
			// Retrieve the required parameters.
			//let properties = response.data.properties;
			// Set UI elements.
			//Property_id_search.init_ui(properties);
		});
	}
}

jQuery(document).ready(function(jQuery){
	Agent_content.init();
	console.log('AGENT CONTENT');
});